import { atom } from 'recoil';

export const forceCallReportUpdate = atom({
  key: 'forceCallReportUpdate',
  default: 0,
});
